// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ZK-z","twoColumnImage":"_K-z"};